<script setup lang="ts">
import { onUnmounted } from 'vue'

import Result from '@desktop/views/Relation/components/RelationView/Summary/Result.vue'
import Summary from '@desktop/views/Relation/components/RelationView/Summary/Summary.vue'
import { useParticipants } from '@desktop/views/Relation/composables'
import { useProbableLineupDeferredClear } from '@desktop/views/Relation/Sports/composables/useProbableLineupDeferredClear'

import MainSummaryParticipant from './MainSummaryParticipant/MainSummaryParticipant.vue'
import { ModalOptions } from './types'

type Props = {
  modalOptions?: ModalOptions
}

const { modalOptions = {} } = defineProps<Props>()

// composables
const { homeParticipant, awayParticipant } = useParticipants()
const { resetDeferredClearState } = useProbableLineupDeferredClear()

onUnmounted(resetDeferredClearState)
</script>

<template>
  <Summary data-testid="main-summary-container">
    <template #top>
      <slot name="top" />
    </template>
    <template #result>
      <div data-testid="main-score">
        <slot name="result">
          <Result />
        </slot>
      </div>
    </template>
    <template #bottom>
      <slot name="bottom" />
    </template>
    <template #home>
      <MainSummaryParticipant
        v-if="homeParticipant"
        :participant="homeParticipant"
        :modalOptions
      />
    </template>
    <template #away>
      <MainSummaryParticipant
        v-if="awayParticipant"
        :participant="awayParticipant"
        :modalOptions
        reversed
      />
    </template>
  </Summary>
</template>
